export const SizeHeightAvatarBase = '2.5rem';
export const SizeHeightAvatarExtraSmall = '2rem';
export const SizeHeightAvatarExtraLarge = '4rem';
export const SizeHeightAvatarSmall = '2.5rem';
export const SizeHeightAvatarMedium = '3rem';
export const SizeHeightAvatarLarge = '3.5rem';
export const SizeHeightAvatarIconBase = '1.5rem';
export const SizeHeightAvatarIconExtraSmall = '1.25rem';
export const SizeHeightAvatarIconExtraLarge = '2.25rem';
export const SizeHeightAvatarIconSmall = '1.5rem';
export const SizeHeightAvatarIconMedium = '1.75rem';
export const SizeHeightAvatarIconLarge = '2rem';
export const SizeHeightButtonDefaultBase = '2.25rem';
export const SizeHeightButtonDefaultMedium = '3rem';
export const SizeHeightButtonDefaultLarge = '3.75rem';
export const SizeHeightButtonContainedPrice = '4rem';
export const SizeHeightButtonIconBase = '2rem';
export const SizeHeightButtonIconLarge = '2.5rem';
export const SizeHeightButtonIconFloating = '3rem';
export const SizeHeightButtonIconFloatingLarge = '4.5rem';
export const SizeHeightIconButtonDefaultBase = '1rem';
export const SizeHeightIconButtonDefaultLarge = '1.5rem';
export const SizeHeightIconButtonIconBase = '1.5rem';
export const SizeHeightIconButtonIconLarge = '2rem';
export const SizeHeightIconSmall = '1rem';
export const SizeHeightIconMedium = '1.5rem';
export const SizeHeightIconLarge = '2rem';
export const SizeHeightCheckboxBase = '1.25rem';
export const SizeHeightChip = '2.25rem';
export const SizeHeightInputBase = '3rem';
export const SizeHeightListIconBase = '3rem';
export const SizeHeightPaymentIconSmall = '1.5rem';
export const SizeHeightPaymentIconMedium = '2rem';
export const SizeHeightPaymentIconLarge = '3rem';
export const SizeHeightRadioBase = '1.25rem';
export const SizeHeightRadioCheckedCircle = '0.5rem';
export const SizeHeightSegmentBase = '2rem';
export const SizeHeightSwitchCircleSmall = '1.5rem';
export const SizeHeightSwitchCircleMedium = '2rem';
export const SizeHeightSwitchTrackSmall = '1rem';
export const SizeHeightSwitchTrackMedium = '1.5rem';
export const SizeHeightTabsBase = '3rem';
export const SizeHeightTagMedium = '1.5rem';
export const SizeHeightTagLarge = '2rem';
export const SizeHeightTooltipArrowDialogBase = '0.875rem';
export const SizeWidthAvatarBase = '2.5rem';
export const SizeWidthAvatarExtraSmall = '2rem';
export const SizeWidthAvatarExtraLarge = '4rem';
export const SizeWidthAvatarSmall = '2.5rem';
export const SizeWidthAvatarMedium = '3rem';
export const SizeWidthAvatarLarge = '3.5rem';
export const SizeWidthAvatarIconBase = '1.5rem';
export const SizeWidthAvatarIconExtraSmall = '1.25rem';
export const SizeWidthAvatarIconExtraLarge = '2.25rem';
export const SizeWidthAvatarIconSmall = '1.5rem';
export const SizeWidthAvatarIconMedium = '1.75rem';
export const SizeWidthAvatarIconLarge = '2rem';
export const SizeWidthButtonDefaultBase = '4.75rem';
export const SizeWidthButtonDefaultLarge = '20.5rem';
export const SizeWidthButtonDefaultFluid = '4.75rem';
export const SizeWidthButtonIconBase = '2rem';
export const SizeWidthButtonIconLarge = '2.5rem';
export const SizeWidthButtonIconFloating = '3rem';
export const SizeWidthButtonIconFloatingLarge = '4.5rem';
export const SizeWidthIconButtonDefaultBase = '1rem';
export const SizeWidthIconButtonDefaultLarge = '1.5rem';
export const SizeWidthIconButtonIconBase = '1.5rem';
export const SizeWidthIconButtonIconLarge = '2rem';
export const SizeWidthIconSmall = '1rem';
export const SizeWidthIconMedium = '1.5rem';
export const SizeWidthIconLarge = '2rem';
export const SizeWidthCheckboxBase = '1.25rem';
export const SizeWidthInputOtpSingle = '3rem';
export const SizeWidthInputOtpWrapper = '3.5rem';
export const SizeWidthListIconBase = '3rem';
export const SizeWidthModalDesktop = '26.25rem';
export const SizeWidthModalMobile = '20.5rem';
export const SizeWidthNotificationBannerFloatingDesktop = '25rem';
export const SizeWidthPaymentIconSmall = '1.5rem';
export const SizeWidthPaymentIconMedium = '2rem';
export const SizeWidthPaymentIconLarge = '3rem';
export const SizeWidthRadioBase = '1.25rem';
export const SizeWidthRadioCheckedCircle = '0.5rem';
export const SizeWidthSwitchCircleSmall = '1.5rem';
export const SizeWidthSwitchCircleMedium = '2rem';
export const SizeWidthSwitchTrackSmall = '2.5rem';
export const SizeWidthSwitchTrackMedium = '3rem';
export const SizeWidthTabsBase = '7.5rem';
export const SizeWidthToastBase = '20.5rem';
export const SizeWidthTooltipBase = '15.5rem';
export const SizeWidthTooltipArrowDialogBase = '0.875rem';
export const SizeMarginAvatarLeftBase = '0.5rem';
export const SizeMarginAvatarLeftExtraSmall = '0.5rem';
export const SizeMarginAvatarLeftExtraLarge = '1rem';
export const SizeMarginAvatarLeftSmall = '0.5rem';
export const SizeMarginAvatarLeftMedium = '0.75rem';
export const SizeMarginAvatarLeftLarge = '0.75rem';
export const SizeMarginIconButtonIconRightBase = '0.25rem';
export const SizeMarginIconButtonIconRightLarge = '0.5rem';
export const SizeMarginChipBase = '0.5rem';
export const SizeMarginErrorBannerIcon = '0.5rem';
export const SizeMarginErrorBannerAction = '0.5rem';
export const SizeMarginInputBottom = '1rem';
export const SizeMarginListSmall = '0.25rem';
export const SizeMarginListMedium = '0.5rem';
export const SizeMarginNotificationBannerIcon = '0.5rem';
export const SizeMarginNotificationBannerMobile = '1rem';
export const SizePaddingButtonDefaultBase = '1rem';
export const SizePaddingButtonDefaultMedium = '1.25rem';
export const SizePaddingButtonDefaultLarge = '1.5rem';
export const SizePaddingChipX = '0.75rem';
export const SizePaddingChipY = '0.5rem';
export const SizePaddingDialogBase = '1rem';
export const SizePaddingErrorBannerMedium = '0.5rem';
export const SizePaddingErrorBannerHigh = '0.75rem';
export const SizePaddingInputBase = '0.75rem';
export const SizePaddingInputOtpSingleX = '0.25rem';
export const SizePaddingInputOtpSingleY = '0rem';
export const SizePaddingListBase = '1rem';
export const SizePaddingListSmall = '0.25rem';
export const SizePaddingListMedium = '0.75rem';
export const SizePaddingModalDesktop = '1.5rem';
export const SizePaddingModalMobile = '1rem';
export const SizePaddingNotificationBannerBase = '0.75rem';
export const SizePaddingTabsBase = '0.75rem';
export const SizePaddingToastBase = '0.75rem';
export const SizeFontButtonDefaultBase = '0.875rem';
export const SizeFontButtonDefaultMedium = '1rem';
export const SizeFontButtonDefaultLarge = '1.125rem';
export const SizeFontButtonContainedPrice = '1.4375rem';
export const SizeFontErrorBannerMedium = '0.75rem';
export const SizeFontErrorBannerHigh = '0.875rem';
export const SizeFontInputBase = '1rem';
export const SizeFontLinkSmall = '0.75rem';
export const SizeFontLinkMedium = '0.875rem';
export const SizeFontLinkLarge = '1rem';
export const SizeFontPointsBase = '0.875rem';
export const SizeFontTagBase = '0.75rem';
export const SizeFontTooltipBase = '0.875rem';
export const SizeFontTypographyH1 = '2rem';
export const SizeFontTypographyH2 = '1.8125rem';
export const SizeFontTypographyH3 = '1.4375rem';
export const SizeFontTypographyH4 = '1.25rem';
export const SizeFontTypographyH5 = '1.125rem';
export const SizeFontTypographyH6 = '1rem';
export const SizeFontTypographySubhead1 = '0.875rem';
export const SizeFontTypographySubhead2 = '0.75rem';
export const SizeFontTypographyBody1 = '1.25rem';
export const SizeFontTypographyBody2 = '1rem';
export const SizeFontTypographyBody3 = '0.875rem';
export const SizeFontTypographyBody4 = '0.75rem';
export const SizeFontTypographyPrice1 = '1.4375rem';
export const SizeFontTypographyPrice2 = '1.25rem';
export const SizeFontTypographyPrice3 = '1rem';
export const SizeFontTypographyPrice4 = '0.875rem';
export const SizeFontTypographyPrice5 = '0.75rem';
export const SizeFontTypographyTitleXxl = '2rem';
export const SizeFontTypographyTitleXl = '1.8125rem';
export const SizeFontTypographyTitleL = '1.4375rem';
export const SizeFontTypographyTitleM = '1.25rem';
export const SizeFontTypographyTitleS = '1.125rem';
export const SizeFontTypographyTitleXs = '1rem';
export const SizeFontTypographyBodyLBold = '1.125rem';
export const SizeFontTypographyBodyLRegular = '1.125rem';
export const SizeFontTypographyBodyMBold = '1rem';
export const SizeFontTypographyBodyM = '1rem';
export const SizeFontTypographyBodySBold = '0.875rem';
export const SizeFontTypographyBodyS = '0.875rem';
export const SizeFontTypographyCaption1Regular = '0.75rem';
export const SizeFontTypographyCaption1Bold = '0.75rem';
export const SizeFontTypographyCaption2Regular = '0.6875rem';
export const SizeFontTypographyCaption2Bold = '0.6875rem';
export const SizeFontTypographyPriceXl = '1.8125rem';
export const SizeFontTypographyPriceL = '1.4375rem';
export const SizeFontTypographyPriceM = '1.25rem';
export const SizeFontTypographyPriceS = '1.125rem';
export const SizeFontTypographyPriceXs = '1rem';
export const SizeFontTypographyPriceXxs = '0.875rem';
export const SizeFontXxl = '2rem';
export const SizeFontXl = '1.8125rem';
export const SizeFontL = '1.4375rem';
export const SizeFontM = '1.25rem';
export const SizeFontSm = '1.125rem';
export const SizeFontS = '1rem';
export const SizeFontXs = '0.875rem';
export const SizeFontXxs = '0.75rem';
export const SizeFontXxxs = '0.6875rem';
export const SizeLineHeightButtonDefaultBase = '1.25rem';
export const SizeLineHeightButtonDefaultMedium = '1.5rem';
export const SizeLineHeightButtonDefaultLarge = '1.75rem';
export const SizeLineHeightButtonContainedPrice = '2rem';
export const SizeLineHeightErrorBannerMedium = '1rem';
export const SizeLineHeightErrorBannerHigh = '1.25rem';
export const SizeLineHeightInputBase = '1.5rem';
export const SizeLineHeightLinkSmall = '1rem';
export const SizeLineHeightLinkMedium = '1.25rem';
export const SizeLineHeightLinkLarge = '1.5rem';
export const SizeLineHeightPointsBase = '1.25rem';
export const SizeLineHeightTagBase = '1rem';
export const SizeLineHeightTooltipBase = '1.43rem';
export const SizeLineHeightTypographyH1 = '2.75rem';
export const SizeLineHeightTypographyH2 = '2.5rem';
export const SizeLineHeightTypographyH3 = '2rem';
export const SizeLineHeightTypographyH4 = '1.75rem';
export const SizeLineHeightTypographyH5 = '1.75rem';
export const SizeLineHeightTypographyH6 = '1.5rem';
export const SizeLineHeightTypographySubhead1 = '1.25rem';
export const SizeLineHeightTypographySubhead2 = '1rem';
export const SizeLineHeightTypographyBody1 = '1.75rem';
export const SizeLineHeightTypographyBody2 = '1.5rem';
export const SizeLineHeightTypographyBody3 = '1.25rem';
export const SizeLineHeightTypographyBody4 = '1rem';
export const SizeLineHeightTypographyPrice1 = '2rem';
export const SizeLineHeightTypographyPrice2 = '1.75rem';
export const SizeLineHeightTypographyPrice3 = '1.5rem';
export const SizeLineHeightTypographyPrice4 = '1.25rem';
export const SizeLineHeightTypographyPrice5 = '1rem';
export const SizeLineHeightTypographyTitleXxl = '2.75rem';
export const SizeLineHeightTypographyTitleXl = '2.5rem';
export const SizeLineHeightTypographyTitleL = '2rem';
export const SizeLineHeightTypographyTitleM = '1.75rem';
export const SizeLineHeightTypographyTitleS = '1.75rem';
export const SizeLineHeightTypographyTitleXs = '1.25rem';
export const SizeLineHeightTypographyBodyLBold = '1.75rem';
export const SizeLineHeightTypographyBodyLRegular = '1.75rem';
export const SizeLineHeightTypographyBodyMBold = '1.5rem';
export const SizeLineHeightTypographyBodyM = '1.5rem';
export const SizeLineHeightTypographyBodySBold = '1.25rem';
export const SizeLineHeightTypographyBodyS = '1.25rem';
export const SizeLineHeightTypographyCaption1Regular = '1rem';
export const SizeLineHeightTypographyCaption1Bold = '1rem';
export const SizeLineHeightTypographyCaption2Regular = '1rem';
export const SizeLineHeightTypographyCaption2Bold = '1rem';
export const SizeLineHeightTypographyPriceXl = '2.25rem';
export const SizeLineHeightTypographyPriceL = '1.75rem';
export const SizeLineHeightTypographyPriceM = '1.5rem';
export const SizeLineHeightTypographyPriceS = '1.25rem';
export const SizeLineHeightTypographyPriceXs = '1.25rem';
export const SizeLineHeightTypographyPriceXxs = '1rem';
export const SizeLineHeightXxl = '2.75rem';
export const SizeLineHeightXl = '2.5rem';
export const SizeLineHeightL2 = '2.25rem';
export const SizeLineHeightL = '2rem';
export const SizeLineHeightM = '1.75rem';
export const SizeLineHeightSm = '1.75rem';
export const SizeLineHeightS = '1.5rem';
export const SizeLineHeightXs = '1.25rem';
export const SizeLineHeightXxs = '1rem';
export const SizeBorderWeightButtonOutlinedBase = '0.0625rem';
export const SizeBorderRadiusButtonBase = '0.25rem';
export const SizeBorderRadiusCheckboxBase = '0.125rem';
export const SizeBorderRadiusChip = '3.125rem';
export const SizeBorderRadiusInputBase = '0.25rem';
export const SizeBorderRadiusModalBase = '0.5rem';
export const SizeBorderRadiusSegmentBase = '0.25rem';
export const SizeBorderRadiusSwitchTrackBase = '1rem';
export const SizeBorderRadiusTagMedium = '0.75rem';
export const SizeBorderRadiusTagLarge = '1rem';
export const SizeBorderRadiusToastBase = '0.25rem';
export const SizeBorderRadiusTooltipBase = '0.25rem';
export const SizeBorderRadiusDefault = '0.25rem';
export const SizeBorderRadiusLarge = '0.5rem';
export const SizeBorderWidthCheckboxBase = '0.0625rem';
export const SizeBorderWidthChip = '0.0625rem';
export const SizeBorderWidthSwitchCircleBase = '0.0625rem';
export const SizeBorderWidthTabsBottomBase = '0.0625rem';
export const SizeBorderWidthTabsBottomActive = '0.125rem';
export const SizeBorderWidthDefault = '0.0625rem';
export const SizeShadowButtonActiveHOffset = '0rem';
export const SizeShadowButtonActiveVOffset = '0rem';
export const SizeShadowButtonActiveBlurRadius = '0rem';
export const SizeShadowButtonActiveSpreadRadius = '0.1875rem';
export const SizeShadowButtonFloatingHOffset = '0rem';
export const SizeShadowButtonFloatingVOffset = '1.125rem';
export const SizeShadowButtonFloatingBlurRadius = '2.25rem';
export const SizeShadowButtonFloatingSpreadRadius = '0rem';
export const SizeShadowCheckboxHOffset = '0rem';
export const SizeShadowCheckboxVOffset = '0rem';
export const SizeShadowCheckboxBlurRadius = '0rem';
export const SizeShadowCheckboxSpreadRadius = '0.125rem';
export const SizeShadowDialogHOffset = '0rem';
export const SizeShadowDialogVOffset = '1.125rem';
export const SizeShadowDialogBlurRadius = '2.25rem';
export const SizeShadowDialogSpreadRadius = '0rem';
export const SizeShadowInputActiveHOffset = '0rem';
export const SizeShadowInputActiveVOffset = '0rem';
export const SizeShadowInputActiveBlurRadius = '0rem';
export const SizeShadowInputActiveSpreadRadius = '0.1875rem';
export const SizeShadowRadioHOffset = '0rem';
export const SizeShadowRadioVOffset = '0rem';
export const SizeShadowRadioBlurRadius = '0rem';
export const SizeShadowRadioSpreadRadius = '0.125rem';
export const SizeShadowSwitchCircleBaseHOffset = '0rem';
export const SizeShadowSwitchCircleBaseVOffset = '0.125rem';
export const SizeShadowSwitchCircleBaseBlurRadius = '0.25rem';
export const SizeShadowSwitchCircleBaseSpreadRadius = '0rem';
export const SizeShadowSwitchCircleHoverHOffset = '0rem';
export const SizeShadowSwitchCircleHoverVOffset = '0rem';
export const SizeShadowSwitchCircleHoverBlurRadius = '0rem';
export const SizeShadowSwitchCircleHoverSpreadRadius = '0.1875rem';
export const SizeShadowToastBaseHOffset = '0rem';
export const SizeShadowToastBaseVOffset = '0.75rem';
export const SizeShadowToastBaseBlurRadius = '1.5rem';
export const SizeShadowToastBaseSpreadRadius = '0rem';
export const SizeShadowTooltipDialogHOffset = '0rem';
export const SizeShadowTooltipDialogVOffset = '0.75rem';
export const SizeShadowTooltipDialogBlurRadius = '1.5rem';
export const SizeShadowTooltipDialogSpreadRadius = '0rem';
export const SizeShadowTooltipTextHOffset = '0rem';
export const SizeShadowTooltipTextVOffset = '0.125rem';
export const SizeShadowTooltipTextBlurRadius = '0.25rem';
export const SizeShadowTooltipTextSpreadRadius = '0rem';
export const SizeBorderRadiusErrorBannerBase = '0.25rem';
export const SizeBorderRadiusNotificationBannerBase = '0.25rem';
export const SizeBorderRadiusSkeletonSmall = '0.125rem';
export const SizeBorderRadiusSkeletonMedium = '0.25rem';
export const SizeIconErrorBannerMedium = '1rem';
export const SizeIconErrorBannerHigh = '1.5rem';
export const SizeIconNotificationBannerBase = '1.5rem';
export const SizePositionNotificationBannerFloatingBase = '0.5rem';
export const SizeBreakpointsXs = '0px';
export const SizeBreakpointsS = '768px';
export const SizeBreakpointsM = '1024px';
export const SizeBreakpointsL = '1360px';
export const SizeBreakpointsXl = '1600px';
export const SizePoint11 = '0.6875rem';
export const SizePoint12 = '0.75rem';
export const SizePoint14 = '0.875rem';
export const SizePoint16 = '1rem';
export const SizePoint18 = '1.125rem';
export const SizePoint20 = '1.25rem';
export const SizePoint23 = '1.4375rem';
export const SizePoint29 = '1.825rem';
export const SizePoint32 = '2rem';
export const SizeElevation100HOffset = '0rem';
export const SizeElevation100VOffset = '0.125rem';
export const SizeElevation100BlurRadius = '0.25rem';
export const SizeElevation100SpreadRadius = '0rem';
export const SizeElevation300HOffset = '0rem';
export const SizeElevation300VOffset = '0.375rem';
export const SizeElevation300BlurRadius = '0.75rem';
export const SizeElevation300SpreadRadius = '0rem';
export const SizeElevation600HOffset = '0rem';
export const SizeElevation600VOffset = '0.75rem';
export const SizeElevation600BlurRadius = '1.5rem';
export const SizeElevation600SpreadRadius = '0rem';
export const SizeElevation900HOffset = '0rem';
export const SizeElevation900VOffset = '1.125rem';
export const SizeElevation900BlurRadius = '2.25rem';
export const SizeElevation900SpreadRadius = '0rem';
export const SizeSpacing02 = '0.5rem';
export const SizeSpacing04 = '1rem';
export const SizeSpacingDefault = '0.5rem';
export const ColorFontButtonDefaultBase = '#1454b8';
export const ColorFontButtonDefaultDisabled = 'rgba(51, 51, 51, 0.35)';
export const ColorFontButtonDefaultLoading = '#666666';
export const ColorFontButtonContainedDisabled = 'rgba(51, 51, 51, 0.35)';
export const ColorFontButtonContainedPrice = '#ffffff';
export const ColorFontButtonContainedGrey = '#333333';
export const ColorFontButtonContainedGreyLoading = '#333333';
export const ColorFontButtonContainedError = '#ffffff';
export const ColorFontButtonContainedErrorLoading = '#ffffff';
export const ColorFontButtonContainedLoading = '#ffffff';
export const ColorFontButtonContainedDarkBase = '#1454b8';
export const ColorFontButtonContainedDarkDisabled = 'rgba(242, 242, 242, 0.35)';
export const ColorFontButtonIconBase = '#1454b8';
export const ColorFontButtonIconDisabled = 'rgba(51, 51, 51, 0.35)';
export const ColorFontButtonIconGrey = '#666666';
export const ColorFontButtonIconError = '#c10b3a';
export const ColorFontButtonOutlinedBase = '#1454b8';
export const ColorFontButtonOutlinedDisabled = 'rgba(51, 51, 51, 0.35)';
export const ColorFontButtonOutlinedGrey = '#666666';
export const ColorFontButtonOutlinedGreyLoading = '#666666';
export const ColorFontButtonOutlinedError = '#c10b3a';
export const ColorFontButtonOutlinedErrorLoading = '#c10b3a';
export const ColorFontButtonOutlinedLoading = '#1454b8';
export const ColorFontButtonOutlinedDarkBase = '#ffffff';
export const ColorFontButtonOutlinedDarkDisabled = 'rgba(242, 242, 242, 0.35)';
export const ColorFontButtonTextBase = '#1454b8';
export const ColorFontButtonTextDisabled = 'rgba(51, 51, 51, 0.35)';
export const ColorFontButtonTextGrey = '#666666';
export const ColorFontButtonTextGreyLoading = '#666666';
export const ColorFontButtonTextError = '#c10b3a';
export const ColorFontButtonTextErrorLoading = '#c10b3a';
export const ColorFontButtonTextLoading = '#1454b8';
export const ColorFontCheckboxDisabled = '#cccccc';
export const ColorFontChipBase = '#333333';
export const ColorFontChipDisabled = 'rgba(51, 51, 51, 0.35)';
export const ColorFontErrorBannerBase = '#333333';
export const ColorFontInputBase = '#333333';
export const ColorFontInputDisabled = '#cccccc';
export const ColorFontInputLabelBase = '#666666';
export const ColorFontInputLabelHover = '#1454b8';
export const ColorFontInputLabelDisabled = '#cccccc';
export const ColorFontInputLabelError = '#c10b3a';
export const ColorFontLinkBase = '#1454b8';
export const ColorFontLinkDarkMode = '#a3c2f5';
export const ColorFontLinkVisited = '#1454b8';
export const ColorFontLinkVisitedDarkMode = '#a3c2f5';
export const ColorFontLinkActive = '#0b2e65';
export const ColorFontLinkActiveDarkMode = '#e8f0fd';
export const ColorFontLinkDisabled = '#cccccc';
export const ColorFontLinkDisabledDarkMode = '#666666';
export const ColorFontListBase = '#333333';
export const ColorFontListGrey = '#666666';
export const ColorFontNotificationBannerMedium = '#333333';
export const ColorFontNotificationBannerHigh = '#ffffff';
export const ColorFontPointsDisabled = '#cccccc';
export const ColorFontPointsBreakdownBase = '#4d4d4d';
export const ColorFontRadioDisabled = '#cccccc';
export const ColorFontSegmentBase = '#666666';
export const ColorFontSegmentHover = '#1454b8';
export const ColorFontSegmentActive = '#1454b8';
export const ColorFontSegmentSelected = '#1454b8';
export const ColorFontTabsBase = '#666666';
export const ColorFontTabsActive = '#1454b8';
export const ColorFontTabsDisabled = '#cccccc';
export const ColorFontTagOutlinedGrey = '#666666';
export const ColorFontTagOutlinedSecondary = '#db5800';
export const ColorFontTagOutlinedError = '#c10b3a';
export const ColorFontTagOutlinedSuccess = '#2b8251';
export const ColorFontTagContainedBase = '#ffffff';
export const ColorFontTooltipText = '#ffffff';
export const ColorFontTooltipDialogInvertedBg = '#ffffff';
export const ColorFontTypographyBase = '#333333';
export const ColorFontTypographyModeDark = '#ffffff';
export const ColorFontDefault = '#333333';
export const ColorFontDefaultLight = '#4d4d4d';
export const ColorFontGrey = '#666666';
export const ColorFontDisabled = '#666666';
export const ColorFontDisabledLight1 = '#999999';
export const ColorFontDisabledLight2 = '#cccccc';
export const ColorFontDisabledLight3 = '#f2f2f2';
export const ColorFontWhite = '#ffffff';
export const ColorFontSuccess = '#2b8251';
export const ColorFontSuccessLight1 = '#3fc078';
export const ColorFontError = '#c10b3a';
export const ColorFontPrimaryDark2 = '#0b2e65';
export const ColorFontPrimary = '#1454b8';
export const ColorFontPrimaryLight1 = '#2070ef';
export const ColorFontPrimaryLight2 = '#a3c2f5';
export const ColorFontPrimaryLight3 = '#e8f0fd';
export const ColorFontSecondary = '#db5800';
export const ColorFontDisabledAlpha = 'rgba(51, 51, 51, 0.35)';
export const ColorFontDisabledDarkAlpha = 'rgba(242, 242, 242, 0.35)';
export const ColorIconButtonDefaultBase = '#1454b8';
export const ColorIconButtonDefaultGrey = '#666666';
export const ColorIconButtonDefaultError = '#c10b3a';
export const ColorIconButtonDefaultPrice = '#ffffff';
export const ColorIconButtonContainedGrey = '#333333';
export const ColorIconCheckboxBase = '#ffffff';
export const ColorIconErrorBannerMedium = '#1454b8';
export const ColorIconErrorBannerHigh = '#c10b3a';
export const ColorIconInputBase = '#666666';
export const ColorIconInputLabelBase = '#f2f2f2';
export const ColorIconInputLabelSuccess = '#3fc078';
export const ColorIconInputLabelError = '#c10b3a';
export const ColorIconInputLabelDisabled = '#f2f2f2';
export const ColorIconNotificationBannerMedium = '#2070ef';
export const ColorIconNotificationBannerHigh = '#ffffff';
export const ColorIconSwitchBase = '#999999';
export const ColorIconSwitchLoading = '#1454b8';
export const ColorIconSwitchChecked = '#2070ef';
export const ColorIconSwitchDisabled = '#cccccc';
export const ColorBackgroundButtonDefaultHover = '#e8f0fd';
export const ColorBackgroundButtonDefaultActive = '#e8f0fd';
export const ColorBackgroundButtonDefaultGreyActive = '#f2f2f2';
export const ColorBackgroundButtonDefaultErrorActive = '#fee7ed';
export const ColorBackgroundButtonDefaultDisabled = '#cccccc';
export const ColorBackgroundButtonDefaultLoading = '#e8f0fd';
export const ColorBackgroundButtonContainedBase = '#1454b8';
export const ColorBackgroundButtonContainedHover = '#104393';
export const ColorBackgroundButtonContainedActive = '#0b2e65';
export const ColorBackgroundButtonContainedDisabled = 'rgba(102, 102, 102, 0.15)';
export const ColorBackgroundButtonContainedGrey = '#f2f2f2';
export const ColorBackgroundButtonContainedGreyHover = '#cccccc';
export const ColorBackgroundButtonContainedGreyActive = '#999999';
export const ColorBackgroundButtonContainedGreyLoading = '#cccccc';
export const ColorBackgroundButtonContainedError = '#c10b3a';
export const ColorBackgroundButtonContainedErrorHover = '#91082b';
export const ColorBackgroundButtonContainedErrorActive = '#60061d';
export const ColorBackgroundButtonContainedErrorLoading = '#91082b';
export const ColorBackgroundButtonContainedLoading = '#104393';
export const ColorBackgroundButtonContainedDarkBase = '#ffffff';
export const ColorBackgroundButtonContainedDarkHover = '#e8f0fd';
export const ColorBackgroundButtonContainedDarkActive = '#a3c2f5';
export const ColorBackgroundButtonContainedDarkLoading = '#e8f0fd';
export const ColorBackgroundButtonContainedDarkDisabled = 'rgba(242, 242, 242, 0.15)';
export const ColorBackgroundButtonIconHover = '#e8f0fd';
export const ColorBackgroundButtonIconGreyLoading = '#f2f2f2';
export const ColorBackgroundButtonIconGreyHover = '#f2f2f2';
export const ColorBackgroundButtonIconErrorHover = '#fee7ed';
export const ColorBackgroundButtonIconErrorLoading = '#fee7ed';
export const ColorBackgroundButtonIconLoading = '#e8f0fd';
export const ColorBackgroundButtonOutlinedHover = '#e8f0fd';
export const ColorBackgroundButtonOutlinedGreyHover = '#f2f2f2';
export const ColorBackgroundButtonOutlinedGreyLoading = '#f2f2f2';
export const ColorBackgroundButtonOutlinedErrorHover = '#fee7ed';
export const ColorBackgroundButtonOutlinedErrorLoading = '#fee7ed';
export const ColorBackgroundButtonOutlinedLoading = '#e8f0fd';
export const ColorBackgroundButtonOutlinedDarkHover = 'rgba(255, 255, 255, 0.1)';
export const ColorBackgroundButtonOutlinedDarkActive = 'rgba(255, 255, 255, 0.2)';
export const ColorBackgroundButtonOutlinedDarkLoading = 'rgba(255, 255, 255, 0.1)';
export const ColorBackgroundButtonTextHover = '#e8f0fd';
export const ColorBackgroundButtonTextGreyHover = '#f2f2f2';
export const ColorBackgroundButtonTextGreyLoading = '#cccccc';
export const ColorBackgroundButtonTextErrorHover = '#fee7ed';
export const ColorBackgroundButtonTextErrorLoading = '#fee7ed';
export const ColorBackgroundButtonTextLoading = '#e8f0fd';
export const ColorBackgroundCheckboxChecked = '#2070ef';
export const ColorBackgroundCheckboxCheckedHover = '#104393';
export const ColorBackgroundCheckboxCheckedDisabled = '#cccccc';
export const ColorBackgroundCheckboxError = '#c10b3a';
export const ColorBackgroundCheckboxErrorHover = '#91082b';
export const ColorBackgroundChipDefault = '#ffffff';
export const ColorBackgroundChipHover = '#f2f2f2';
export const ColorBackgroundChipActive = '#e8f0fd';
export const ColorBackgroundChipSelectedDisabled = 'rgba(102, 102, 102, 0.15)';
export const ColorBackgroundDialogBase = '#ffffff';
export const ColorBackgroundErrorBannerMedium = '#e8f0fd';
export const ColorBackgroundErrorBannerHigh = '#fee7ed';
export const ColorBackgroundInputDisabled = '#f2f2f2';
export const ColorBackgroundListActive = '#e8f0fd';
export const ColorBackgroundListHover = '#f2f2f2';
export const ColorBackgroundModalBase = '#ffffff';
export const ColorBackgroundNotificationBannerMedium = '#e8f0fd';
export const ColorBackgroundNotificationBannerHigh = '#2070ef';
export const ColorBackgroundNotificationBannerError = '#c10b3a';
export const ColorBackgroundRadioChecked = '#2070ef';
export const ColorBackgroundRadioCheckedCircle = '#ffffff';
export const ColorBackgroundRadioCheckedHover = '#104393';
export const ColorBackgroundRadioCheckedDisabled = '#cccccc';
export const ColorBackgroundSegmentSelected = '#e8f0fd';
export const ColorBackgroundSegmentActive = '#e8f0fd';
export const ColorBackgroundSkeletonDefault = '#eaeaea';
export const ColorBackgroundSkeletonLight = '#f6f6f6';
export const ColorBackgroundSwitchCircleBase = '#ffffff';
export const ColorBackgroundSwitchCircleDisabled = '#f2f2f2';
export const ColorBackgroundSwitchTrackBase = '#cccccc';
export const ColorBackgroundSwitchTrackLoading = '#1454b8';
export const ColorBackgroundSwitchTrackChecked = '#2070ef';
export const ColorBackgroundSwitchTrackDisabled = '#f2f2f2';
export const ColorBackgroundTabsBase = '#ffffff';
export const ColorBackgroundTabsHover = '#e8f0fd';
export const ColorBackgroundTabsFocus = '#a3c2f5';
export const ColorBackgroundTabsActive = '#ffffff';
export const ColorBackgroundTabsDisabled = '#ffffff';
export const ColorBackgroundTagOutlinedBase = '#ffffff';
export const ColorBackgroundTagContainedGrey = '#666666';
export const ColorBackgroundTagContainedSecondary = '#db5800';
export const ColorBackgroundTagContainedError = '#c10b3a';
export const ColorBackgroundTagContainedSuccess = '#2b8251';
export const ColorBackgroundTooltipDialogBase = '#ffffff';
export const ColorBackgroundTooltipDialogInvertedBg = '#2070ef';
export const ColorBackgroundTooltipText = '#333333';
export const ColorBackgroundWhite = '#ffffff';
export const ColorBackgroundDisabled = '#f2f2f2';
export const ColorBackgroundGrey = '#666666';
export const ColorBackgroundGreyLight1 = '#999999';
export const ColorBackgroundGreyLight2 = '#cccccc';
export const ColorBackgroundGreyLight3 = '#f2f2f2';
export const ColorBackgroundGreyDark2 = '#333333';
export const ColorBackgroundBackDrop = 'rgba(0, 0, 0, 0.7)';
export const ColorBackgroundSuccess = '#2b8251';
export const ColorBackgroundErrorDark2 = '#60061d';
export const ColorBackgroundErrorDark1 = '#91082b';
export const ColorBackgroundError = '#c10b3a';
export const ColorBackgroundErrorLight2 = '#f9a0b6';
export const ColorBackgroundErrorLight3 = '#fee7ed';
export const ColorBackgroundPrimaryDark2 = '#0b2e65';
export const ColorBackgroundPrimaryDark1 = '#104393';
export const ColorBackgroundPrimary = '#1454b8';
export const ColorBackgroundPrimaryLight1 = '#2070ef';
export const ColorBackgroundPrimaryLight2 = '#a3c2f5';
export const ColorBackgroundPrimaryLight3 = '#e8f0fd';
export const ColorBackgroundSecondary = '#db5800';
export const ColorBackgroundWhiteAlpha1 = 'rgba(255, 255, 255, 0.1)';
export const ColorBackgroundWhiteAlpha2 = 'rgba(255, 255, 255, 0.2)';
export const ColorBackgroundDisabledAlpha = 'rgba(102, 102, 102, 0.15)';
export const ColorBackgroundDisabledDarkAlpha = 'rgba(242, 242, 242, 0.15)';
export const ColorShadowButtonActive = '#a3c2f5';
export const ColorShadowButtonGreyActive = '#cccccc';
export const ColorShadowButtonErrorActive = '#f9a0b6';
export const ColorShadowButtonFloating = 'rgba(51, 51, 51, 0.18)';
export const ColorShadowButtonDarkContained = '#e8f0fd';
export const ColorShadowButtonDarkOutlined = '#ffffff';
export const ColorShadowCheckboxHover = '#a3c2f5';
export const ColorShadowCheckboxErrorHover = '#f9a0b6';
export const ColorShadowDialogBase = 'rgba(51, 51, 51, 0.18)';
export const ColorShadowInputActive = '#a3c2f5';
export const ColorShadowInputErrorActive = '#f9a0b6';
export const ColorShadowRadioHover = '#a3c2f5';
export const ColorShadowSwitchCircleBase = 'rgba(51, 51, 51, 0.18)';
export const ColorShadowSwitchCircleHover = '#a3c2f5';
export const ColorShadowToastBase = 'rgba(51, 51, 51, 0.18)';
export const ColorShadowTooltipDialog = 'rgba(51, 51, 51, 0.18)';
export const ColorShadowTooltipText = 'rgba(51, 51, 51, 0.18)';
export const ColorBorderButtonOutlinedBase = '#1454b8';
export const ColorBorderButtonOutlinedGrey = '#999999';
export const ColorBorderButtonOutlinedError = '#c10b3a';
export const ColorBorderButtonOutlinedDisabled = 'rgba(102, 102, 102, 0.25)';
export const ColorBorderButtonOutlinedLoading = '#1454b8';
export const ColorBorderButtonOutlinedDarkBase = '#ffffff';
export const ColorBorderButtonOutlinedDarkDisabled = 'rgba(242, 242, 242, 0.25)';
export const ColorBorderCheckboxBase = '#999999';
export const ColorBorderCheckboxChecked = '#2070ef';
export const ColorBorderCheckboxCheckedHover = '#104393';
export const ColorBorderCheckboxDisabled = '#cccccc';
export const ColorBorderCheckboxDisabledHover = '#cccccc';
export const ColorBorderCheckboxHover = '#2070ef';
export const ColorBorderCheckboxError = '#c10b3a';
export const ColorBorderCheckboxErrorHover = '#91082b';
export const ColorBorderChipDefault = '#cccccc';
export const ColorBorderChipActive = '#1454b8';
export const ColorBorderChipDisabled = 'rgba(102, 102, 102, 0.25)';
export const ColorBorderInputBase = '#666666';
export const ColorBorderInputHover = '#1454b8';
export const ColorBorderInputActive = '#1454b8';
export const ColorBorderInputDisabled = '#f2f2f2';
export const ColorBorderRadioBase = '#999999';
export const ColorBorderRadioChecked = '#2070ef';
export const ColorBorderRadioCheckedHover = '#104393';
export const ColorBorderRadioDisabled = '#cccccc';
export const ColorBorderRadioDisabledHover = '#cccccc';
export const ColorBorderRadioHover = '#2070ef';
export const ColorBorderSegmentBase = '#999999';
export const ColorBorderSegmentHover = '#1454b8';
export const ColorBorderSegmentActive = '#1454b8';
export const ColorBorderSegmentSelected = '#1454b8';
export const ColorBorderSwitchCircleBase = '#f2f2f2';
export const ColorBorderTabsBase = '#cccccc';
export const ColorBorderTabsActive = '#1454b8';
export const ColorBorderTagOutlinedGrey = '#666666';
export const ColorBorderTagOutlinedSecondary = '#db5800';
export const ColorBorderTagOutlinedError = '#c10b3a';
export const ColorBorderTagOutlinedSuccess = '#2b8251';
export const ColorBorderDisabled = '#666666';
export const ColorBorderGrey = '#666666';
export const ColorBorderDisabledLight1 = '#999999';
export const ColorBorderDisabledLight2 = '#cccccc';
export const ColorBorderDisabledLight3 = '#f2f2f2';
export const ColorBorderSuccess = '#2b8251';
export const ColorBorderError = '#c10b3a';
export const ColorBorderPrimary = '#1454b8';
export const ColorBorderPrimaryDark1 = '#104393';
export const ColorBorderPrimaryLight1 = '#2070ef';
export const ColorBorderSecondary = '#db5800';
export const ColorBorderDisabledAlpha = 'rgba(102, 102, 102, 0.25)';
export const ColorBorderDisabledDarkAlpha = 'rgba(242, 242, 242, 0.25)';
export const ColorLinkErrorBannerMedium = '#1454b8';
export const ColorLinkErrorBannerHigh = '#c10b3a';
export const ColorUnderlineLinkHover = '#1454b8';
export const ColorUnderlineLinkHoverDarkMode = '#a3c2f5';
export const ColorUnderlineLinkActive = '#0b2e65';
export const ColorUnderlineLinkActiveDarkMode = '#e8f0fd';
export const ColorBaseMineShaft700 = '#333333';
export const ColorBaseMineShaft600 = '#4d4d4d';
export const ColorBaseMineShaft500 = '#666666';
export const ColorBaseMineShaft300 = '#999999';
export const ColorBaseMineShaft100 = '#cccccc';
export const ColorBaseMineShaft80 = '#eaeaea';
export const ColorBaseMineShaft50 = '#f2f2f2';
export const ColorBaseMineShaft40 = '#f6f6f6';
export const ColorBaseShiraz700 = '#60061d';
export const ColorBaseShiraz600 = '#91082b';
export const ColorBaseShiraz500 = '#c10b3a';
export const ColorBaseShiraz300 = '#f43e6d';
export const ColorBaseShiraz100 = '#f9a0b6';
export const ColorBaseShiraz50 = '#fee7ed';
export const ColorBaseGreenPea700 = '#0d2618';
export const ColorBaseGreenPea600 = '#194d30';
export const ColorBaseGreenPea500 = '#2b8251';
export const ColorBaseGreenPea300 = '#3fc078';
export const ColorBaseGreenPea100 = '#8cd9ae';
export const ColorBaseGreenPea50 = '#dcf5e7';
export const ColorBaseBrandPrimary700 = '#0b2e65';
export const ColorBaseBrandPrimary600 = '#104393';
export const ColorBaseBrandPrimary500 = '#1454b8';
export const ColorBaseBrandPrimary300 = '#2070ef';
export const ColorBaseBrandPrimary100 = '#a3c2f5';
export const ColorBaseBrandPrimary50 = '#e8f0fd';
export const ColorBaseBrandSecondary700 = '#662a00';
export const ColorBaseBrandSecondary600 = '#994000';
export const ColorBaseBrandSecondary500 = '#db5800';
export const ColorBaseBrandSecondary300 = '#ff8833';
export const ColorBaseBrandSecondary100 = '#ffc499';
export const ColorBaseBrandSecondary50 = '#fff0e5';
export const ColorBasePrimary40 = '#f9f4fb';
export const ColorBaseWhite = '#ffffff';
export const ColorElevation100 = 'rgba(51, 51, 51, 0.18)';
export const ColorElevation300 = 'rgba(51, 51, 51, 0.18)';
export const ColorElevation600 = 'rgba(51, 51, 51, 0.18)';
export const ColorElevation900 = 'rgba(51, 51, 51, 0.18)';
export const ContentFontWeightButtonDefault = '700';
export const ContentFontWeightButtonContainedPrice = '900';
export const ContentFontWeightPointsBase = '400';
export const ContentFontWeightSegmentBase = '400';
export const ContentFontWeightSegmentSelected = '700';
export const ContentFontWeightTagBase = '400';
export const ContentFontWeightTypographyH1 = '900';
export const ContentFontWeightTypographyH2 = '700';
export const ContentFontWeightTypographyH3 = '700';
export const ContentFontWeightTypographyH4 = '700';
export const ContentFontWeightTypographyH5 = '700';
export const ContentFontWeightTypographyH6 = '700';
export const ContentFontWeightTypographySubhead1 = '700';
export const ContentFontWeightTypographySubhead2 = '700';
export const ContentFontWeightTypographyPrice1 = '900';
export const ContentFontWeightTypographyPrice2 = '900';
export const ContentFontWeightTypographyPrice3 = '900';
export const ContentFontWeightTypographyPrice4 = '900';
export const ContentFontWeightTypographyTitleXxl = '700';
export const ContentFontWeightTypographyTitleXl = '700';
export const ContentFontWeightTypographyTitleL = '700';
export const ContentFontWeightTypographyTitleM = '700';
export const ContentFontWeightTypographyTitleS = '700';
export const ContentFontWeightTypographyTitleXs = '700';
export const ContentFontWeightTypographyBodyLBold = '700';
export const ContentFontWeightTypographyBodyLRegular = '400';
export const ContentFontWeightTypographyBodyMBold = '700';
export const ContentFontWeightTypographyBodyM = '400';
export const ContentFontWeightTypographyBodySBold = '700';
export const ContentFontWeightTypographyBodyS = '400';
export const ContentFontWeightTypographyCaption1Regular = '400';
export const ContentFontWeightTypographyCaption1Bold = '700';
export const ContentFontWeightTypographyCaption2Regular = '400';
export const ContentFontWeightTypographyCaption2Bold = '700';
export const ContentFontWeightTypographyPriceXl = '900';
export const ContentFontWeightTypographyPriceL = '900';
export const ContentFontWeightTypographyPriceM = '900';
export const ContentFontWeightTypographyPriceS = '900';
export const ContentFontWeightTypographyPriceXs = '900';
export const ContentFontWeightTypographyPriceXxs = '900';
export const ContentFontWeightNormal = '400';
export const ContentFontWeightBold = '700';
export const ContentFontWeightBlack = '900';
export const FontFamilyBase = '"Lato",sans-serif';
//# sourceMappingURL=tokens.js.map